import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum'
import { User } from '@datadog/browser-rum-core/cjs/rawRumEvent.types'
import axios from 'axios'
import { getAppConfigSetting } from '.'
import { version } from '../../package.json'

const datadogConfig: RumInitConfiguration = {
  version,
  ...getAppConfigSetting('datadog'),
}

interface RumUser extends User {
  id?: string
  name?: string
  email?: string
  legacyName?: string
  loginType?: string
}

export const startRum = () => {
  datadogRum.init(datadogConfig)
}

const getRumUser = (): RumUser => {
  const rumUser = window.localStorage.getItem('rumUser')
  return rumUser ? JSON.parse(rumUser) : {}
}

export const setRumUser = (user: RumUser) => {
  window.localStorage.setItem('rumUser', JSON.stringify(user))
}

export const updateRumUser = () => {
  datadogRum.setUser(getRumUser())
}

export const setRumSessionUser = async () => {
  try {
    const { data } = await axios.get(
      'https://login.apexfintechsolutions.com/api/v1/sessions/me',
      {
        withCredentials: true,
      }
    )

    const {
      userId: id,
      login: email,
      _links: {
        user: { name },
      },
    } = data

    const rumUser: RumUser = {
      loginType: 'okta',
    }

    if (id) {
      rumUser.id = id
    }
    if (email) {
      rumUser.email = email
    }
    if (name) {
      rumUser.name = name
    }

    setRumUser(rumUser)
  } catch (e) {
    // Swallowing the error
  } finally {
    updateRumUser()
  }
}
export const clearRumUser = () => {
  window.localStorage.removeItem('rumUser')
}
